export default {
  menuData: state => state.data,
  userInfo: state => state.info,
  instituicoes: state => state.instituicoes,
  info: state => state.info
}
